var SessionTimeoutWarningModal = (function() {
  var countdownInterval = null;
  var currentCountdown = 0;
  var isVisible = false;
  var previouslyFocusedElement = null;

  var MODAL_ID = '#sessionTimeoutWarningModal';
  var COUNTDOWN_VALUE_ID = '#sessionTimeoutCountdownValue';
  var COUNTDOWN_LABEL_ID = '#sessionTimeoutCountdownLabel';
  var STAY_BTN_ID = '#sessionTimeoutStayBtn';
  var LOGOUT_BTN_ID = '#sessionTimeoutLogoutBtn';
  var LIVE_REGION_ID = '#sessionTimeoutLiveRegion';

  var SCREEN_READER_ANNOUNCE_AT = [10];

  function show(seconds) {
    if (isVisible) {
      updateCountdown(seconds);
      return;
    }

    var $modal = $(MODAL_ID);
    if ($modal.length === 0) {
      return;
    }

    previouslyFocusedElement = document.activeElement;

    currentCountdown = seconds || 30;
    updateCountdownDisplay();
    bindButtonHandlers();
    $(MODAL_ID).off('keydown.sessionTimeoutTrap').on('keydown.sessionTimeoutTrap', handleFocusTrap);
    startCountdown();

    $modal.one('shown.bs.modal', function() {
      $(STAY_BTN_ID).trigger('focus');
      announceToScreenReader(
        'Session Timeout Warning. Your session is about to expire due to inactivity. ' +
        'You will be logged out in ' + currentCountdown + ' seconds. ' +
        'Press Stay Logged In to continue.'
      );
    });

    $modal.modal('show');
    isVisible = true;
  }

  function hide() {
    var $modal = $(MODAL_ID);
    if ($modal.length > 0) {
      $modal.modal('hide');
    }
    stopCountdown();
    $(MODAL_ID).off('keydown.sessionTimeoutTrap');
    clearLiveRegion();
    isVisible = false;
    resetStayButton();

    if (previouslyFocusedElement && previouslyFocusedElement.focus) {
      previouslyFocusedElement.focus();
      previouslyFocusedElement = null;
    }
  }

  function bindButtonHandlers() {
    $(STAY_BTN_ID).off('click.sessionTimeout').on('click.sessionTimeout', handleStayLoggedIn);
    $(LOGOUT_BTN_ID).off('click.sessionTimeout').on('click.sessionTimeout', handleLogout);
  }

  // --- Focus trapping ---
  // Bootstrap 4 _enforceFocus only pulls focus back to the modal root <div>,
  // which screen readers announce as an unnamed button. This handler keeps
  // Tab / Shift+Tab cycling between the two buttons only.

  function handleFocusTrap(event) {
    var isTabKey = event.key === 'Tab' || event.keyCode === 9;
    if (!isTabKey) { return; }

    var focusableButtons = $(MODAL_ID + ' .modal-footer button:not([disabled])');
    if (focusableButtons.length < 2) { return; }

    var firstButton = focusableButtons[0];
    var lastButton  = focusableButtons[focusableButtons.length - 1];
    var tabbingBackward = event.shiftKey;
    var isOnFirstButton = document.activeElement === firstButton;
    var isOnLastButton  = document.activeElement === lastButton;

    // Wrap focus from first button back to last button
    if (tabbingBackward && isOnFirstButton) {
      event.preventDefault();
      lastButton.focus();
    }

    // Wrap focus from last button back to first button
    if (!tabbingBackward && isOnLastButton) {
      event.preventDefault();
      firstButton.focus();
    }
  }

  // --- Screen reader announcements ---

  function announceToScreenReader(message) {
    var $region = $(LIVE_REGION_ID);
    if ($region.length > 0) {
      $region.text('');
      setTimeout(function() { $region.text(message); }, 50);
    }
  }

  function clearLiveRegion() {
    var $region = $(LIVE_REGION_ID);
    if ($region.length > 0) {
      $region.text('');
    }
  }

  function shouldAnnounce(seconds) {
    for (var i = 0; i < SCREEN_READER_ANNOUNCE_AT.length; i++) {
      if (seconds === SCREEN_READER_ANNOUNCE_AT[i]) { return true; }
    }
    return false;
  }

  // --- Core countdown logic ---

  function handleStayLoggedIn() {
    var $btn = $(STAY_BTN_ID);
    $btn.prop('disabled', true).text('Extending...');

    if (window.sessionActivityTracker) {
      window.sessionActivityTracker.lastActivityTime = Date.now();
      window.sessionActivityTracker.sendHeartbeat('modal_stay_logged_in', true)
        .then(function() {
          window.sessionActivityTracker.resume();
          hide();
        })
        .catch(function(status) {
          if (status === 401) {
            window.location = '/timeout?logout=true';
          } else {
            resetStayButton();
          }
        });
    }
  }

  function resetStayButton() {
    $(STAY_BTN_ID).prop('disabled', false).text('Stay Logged In');
  }

  function handleLogout() {
    window.location = '/timeout?logout=true';
  }

  function updateCountdown(seconds) {
    currentCountdown = seconds;
    updateCountdownDisplay();
  }

  function startCountdown() {
    stopCountdown();

    countdownInterval = setInterval(function() {
      currentCountdown--;

      if (currentCountdown <= 0) {
        stopCountdown();
        window.location = '/timeout?logout=true';
      } else {
        updateCountdownDisplay();

        if (shouldAnnounce(currentCountdown)) {
          var label = currentCountdown === 1 ? 'second' : 'seconds';
          announceToScreenReader(currentCountdown + ' ' + label + ' remaining');
        }
      }
    }, 1000);
  }

  function stopCountdown() {
    if (countdownInterval) {
      clearInterval(countdownInterval);
      countdownInterval = null;
    }
  }

  function updateCountdownDisplay() {
    var $value = $(COUNTDOWN_VALUE_ID);
    var $label = $(COUNTDOWN_LABEL_ID);

    if ($value.length > 0) {
      $value.text(currentCountdown);
    }

    if ($label.length > 0) {
      $label.text(currentCountdown === 1 ? 'second' : 'seconds');
    }
  }

  function getStatus() {
    return {
      isVisible: isVisible,
      currentCountdown: currentCountdown
    };
  }

  return {
    show: show,
    hide: hide,
    updateCountdown: updateCountdown,
    getStatus: getStatus
  };
})();

window.SessionTimeoutWarningModal = SessionTimeoutWarningModal;
